import moment from "moment"

/**
 * "8 Oct 2027" for an enrolment's `expires_at`, which the server sends as a
 * UTC timestamp without a zone; null when there is none.
 */
export const formatAccessUntil = (expires_at) =>
    expires_at ? moment.utc(expires_at).local().format("D MMM YYYY") : null
